<template>
  <div>
    <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
      <vx-card no-shadow class="custom-min-height">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">

            <div class="vx-row flex flex-wrap mb-4">
              <div class="vx-col w-full">
                <validation-provider :name="form.signerDetail1Modal.name" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">{{ form.signerDetail1Modal.name }}* <a class="cursor-pointer" @click="form.signerDetail1Modal.active = true"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                  <v-select v-model="form.signerDetail1Modal.signerId" :clearable="false" :options="signerPositionOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row flex flex-wrap mb-4">
              <div class="vx-col w-full">
                <validation-provider :name="form.signerDetail2Modal.name" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">{{ form.signerDetail2Modal.name }}* <a class="cursor-pointer" @click="form.signerDetail2Modal.active = true"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                  <v-select v-model="form.signerDetail2Modal.signerId" :clearable="false" :options="signerPositionOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row flex flex-wrap mb-4">
              <div class="vx-col w-full">
                <validation-provider :name="form.signerDetail3Modal.name" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">{{ form.signerDetail3Modal.name }}* <a class="cursor-pointer" @click="form.signerDetail3Modal.active = true"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></label>
                  <v-select v-model="form.signerDetail3Modal.signerId" :clearable="false" :options="signerPositionOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full flex flex-col sm:flex-row sm:justify-end mt-base">
                <vs-button class="ml-auto mt-2" @click="summit()">บันทึก</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning">คืนค่า</vs-button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
    <vs-popup
      :active.sync="form.signerDetail1Modal.active"
      :title="form.signerDetail1Modal.name"
      class="custom-popup"
    >
      <div class="popup-content">
        <span v-html="form.signerDetail1Modal.description"></span>
      </div>
    </vs-popup>
    <vs-popup
      :active.sync="form.signerDetail2Modal.active"
      :title="form.signerDetail2Modal.name"
      class="custom-popup"
    >
      <div class="popup-content">
        <span v-html="form.signerDetail2Modal.description"></span>
      </div>
    </vs-popup>
    <vs-popup
      :active.sync="form.signerDetail3Modal.active"
      :title="form.signerDetail3Modal.name"
      class="custom-popup"
    >
      <div class="popup-content">
        <span v-html="form.signerDetail3Modal.description"></span>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import {ValidationProvider} from "vee-validate";
import {createNamespacedHelpers, mapGetters} from "vuex";
const { mapActions: mapSystemActions, mapState: mapSystemState } = createNamespacedHelpers('System')
const { mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  components: {
    ValidationProvider,
    vSelect
  },
  data() {
    return {
      form: {
        signerDetail1Modal: {
          active: false,
          id: '',
          signerId: '',
          name: '',
          description: '',
        },
        signerDetail2Modal: {
          active: false,
          id: '',
          signerId: '',
          name: '',
          description: '',
        },
        signerDetail3Modal: {
          active: false,
          id: '',
          signerId: '',
          name: '',
          description: '',
        },
      }
    };
  },
  computed: {
    ...mapSystemState(['status', 'configSigner']),
    ...mapGetters({
      signerPositionOptions: "Master/signerPositionOptions",
    }),
  },
  methods: {
    ...mapSystemActions([
      'initializing',
      'getConfigSigner',
      'updateConfigSigner'
    ]),
    ...mapMasterActions(['getSignerOptions']),
    async summit () {
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const {updateConfigSigner} = vm
        updateConfigSigner({
          form: {
            signerDetails: [
              {
                id: vm.form.signerDetail1Modal.id,
                signerId: vm.form.signerDetail1Modal.signerId,
              },
              {
                id: vm.form.signerDetail2Modal.id,
                signerId: vm.form.signerDetail2Modal.signerId,
              },
              {
                id: vm.form.signerDetail3Modal.id,
                signerId: vm.form.signerDetail3Modal.signerId,
              },
            ]
          },
          vm
        })
      })
    },
    async initDate() {
      const vm = this;
      const { getConfigSigner } = vm
      // set form data
      await getConfigSigner();
      for (let i = 0; i < vm.configSigner.signerDetails.length; i++) {
        const signerDetail = vm.configSigner.signerDetails[i]
        if (i === 0) {
          vm.form.signerDetail1Modal = {
            active: false,
            id: signerDetail.id,
            signerId: signerDetail.signerId,
            name: signerDetail.name,
            description: signerDetail.description,
          }
        } else if (i === 1) {
          vm.form.signerDetail2Modal = {
            active: false,
            id: signerDetail.id,
            signerId: signerDetail.signerId,
            name: signerDetail.name,
            description: signerDetail.description,
          }
        } else if (i === 2) {
          vm.form.signerDetail3Modal = {
            active: false,
            id: signerDetail.id,
            signerId: signerDetail.signerId,
            name: signerDetail.name,
            description: signerDetail.description,
          }
        }
      }
    }
  },
  async created () {
    const vm = this
    const { getSignerOptions } = vm
    await getSignerOptions()
    await this.initDate()
  },
};
</script>

<style scoped>
.custom-min-height {
  min-height: 500px; /* Set your desired minimum height */
}
.position-bottom-right {
  align-self: flex-end;
  margin: 16px; /* Adjust the margin as needed */
}
</style>
